import {
  CheckoutWithClaimDTO,
  OrderCustomerActionDTO,
  OrderCustomerDTO,
  OrderWithOrderCustomersDTO,
  TenancyDTO,
  TenancyOrderNoteDTO,
  TenantDTO,
  UserDTO,
} from '@reposit/api-client';
import { get, sortBy } from 'lodash';
import { denormalize } from 'normalizr';
import { AppState } from '../root.reducer';
import SCHEMA from '../schema';

export interface GetTenancyOrderProps {
  tenancyOrderId: string;
}

export interface TenantWithActions extends TenantDTO {
  actions: OrderCustomerActionDTO[];
}

export interface TenancyWithTenantActions extends Omit<TenancyDTO, 'tenants'> {
  tenants: TenantWithActions[];
  checkout: CheckoutWithClaimDTO;
}

export interface TenancyOrderWithActions {
  id: string;
  tenancy: TenancyWithTenantActions;
  order: OrderWithOrderCustomersDTO;
  tenancyOrderNotes: TenancyOrderNoteDTO[];
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  deactivationReason?: string;
  deactivatedByUser?: UserDTO;
}

export const getTenancyOrder = (state: AppState, props: GetTenancyOrderProps): TenancyOrderWithActions | undefined => {
  if (!state.entities.tenancyOrder) return undefined;

  const tenancyOrder = denormalize(state.entities.tenancyOrder[props.tenancyOrderId], SCHEMA.tenancyOrder, state.entities);

  if (!tenancyOrder || !tenancyOrder.tenancy || !tenancyOrder.order) return undefined;

  if (tenancyOrder.tenancy.PPM) {
    tenancyOrder.tenancy.PPM = (tenancyOrder.tenancy.PPM / 100).toFixed(2);
  }

  if (get(tenancyOrder, 'tenancy.tenants', []).length) {
    const orderCustomers = get<OrderCustomerDTO[]>(tenancyOrder, 'order.orderCustomers', []);
    const existingTenants = get(tenancyOrder, 'tenancy.tenants');
    const sortedTenants = sortBy(existingTenants, 'createdAt');
    tenancyOrder.tenancy.tenants = sortedTenants;

    if (orderCustomers.length) {
      tenancyOrder.tenancy.tenants = tenancyOrder.tenancy.tenants.map((tenant: TenantDTO) => {
        const userId = tenant.userId;
        const orderCustomer = orderCustomers.find((oc) => oc.customer.userId === userId);
        return {
          ...tenant,
          actions: orderCustomer ? orderCustomer.actions : [],
        };
      });
    }
  }
  return tenancyOrder;
};

export const getTenancyOrderNotes = (state: AppState, props: GetTenancyOrderProps): TenancyOrderNoteDTO[] | undefined => {
  const tenancyOrder = get(state, ['entities', 'tenancyOrder', props.tenancyOrderId]);
  if (!tenancyOrder || tenancyOrder.tenancyOrderNotes === undefined) return undefined;

  return denormalize(tenancyOrder.tenancyOrderNotes, SCHEMA.tenancyOrderNotes, state.entities);
};
